// facility detail page-specific sticky header
( function() {
	const facilityDetailPage = document.querySelector( '.template-facility' );
	if( !facilityDetailPage ) { return; }

	const navbarContent = facilityDetailPage.querySelector( '.navbar__content' );
	const facilityName = facilityDetailPage.querySelector( 'h1' ).textContent.trim();
	const facilityCity = facilityDetailPage.querySelector( 'span[itemprop="addressLocality"]' );
	const facilityState = facilityDetailPage.querySelector( 'span[itemprop="addressRegion"]' );

	if( !facilityName || !facilityCity || !facilityState ) { return; }

	// create facility info div
	const facilityInfo = document.createElement( 'div' );
	facilityInfo.classList.add( 'navbar__facility-info' );
	facilityInfo.innerHTML += `
		<p class="navbar__facility-name">${facilityName}</p>
		<p class="navbar__facility-location">${facilityCity.textContent.trim()}, ${facilityState.textContent.trim()}</p>
	`;

	navbarContent.prepend( facilityInfo );
} )();